// extracted by mini-css-extract-plugin
export default {"tooltip":"GQ-z","arrow":"HQ-z"};